// Chuỗi AN TOÀN để gửi model (lỗi thật 08/10/2026, plugin 0.1.65, Bot 333, bước cham_lien_quan_2 — DeepSeek HTTP 400 "messages[1].content:
// unexpected end of hex escape"). Chuỗi JS là UTF-16: emoji = 2 đơn vị (cặp surrogate). Cắt bằng .slice/.substring có thể cắt đôi cặp, và
// chữ trang web cũng có thể mang sẵn nửa cặp. JSON.stringify ghi nửa cặp thành "\ud83d" — JS/Node đọc được, nhưng bộ đọc JSON nghiêm (serde
// của DeepSeek) từ chối CẢ request. Quy tắc: cắt theo KÝ TỰ Unicode (catKyTu), và mọi thân gửi model đi qua jsonAnToan (nửa cặp → U+FFFD).
// Dùng chung cho plugin (src/background/model.ts) và server (proxy model, model-client).

const NUA_CAP = /[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?<![\uD800-\uDBFF])[\uDC00-\uDFFF]/g;

/** Thay mọi nửa cặp surrogate lẻ bằng U+FFFD; chuỗi đã đúng giữ nguyên (cùng độ dài UTF-16). */
export function chuoiHopLe(s: string): string {
  return s.replace(NUA_CAP, "�");
}

/** Cắt còn tối đa n KÝ TỰ Unicode (không cắt đôi emoji); có `duoi` (vd "…") thì chỉ thêm khi thật sự cắt, tổng vẫn ≤ n ký tự. n ≤ 0 / NaN → "". */
export function catKyTu(s: string, n: number, duoi = ""): string {
  const kt = Array.from(chuoiHopLe(s));
  const toiDa = Number.isFinite(n) ? Math.max(0, Math.floor(n)) : 0;
  if (kt.length <= toiDa) return kt.join("");
  const dk = Array.from(duoi);
  if (dk.length >= toiDa) return kt.slice(0, toiDa).join("");
  return kt.slice(0, toiDa - dk.length).join("") + duoi;
}

/** Làm sạch đệ quy mọi chuỗi (kể cả khoá đối tượng) trong giá trị sắp JSON.stringify. */
export function lamSachChuoi<T>(v: T): T {
  if (typeof v === "string") return chuoiHopLe(v) as T;
  if (Array.isArray(v)) return v.map((x) => lamSachChuoi(x)) as T;
  if (v && typeof v === "object") {
    const out: Record<string, unknown> = {};
    for (const [k, x] of Object.entries(v as Record<string, unknown>)) out[chuoiHopLe(k)] = lamSachChuoi(x);
    return out as T;
  }
  return v;
}

/** JSON.stringify không bao giờ sinh escape surrogate lẻ — dùng cho MỌI thân request gửi model. */
export function jsonAnToan(v: unknown): string {
  return JSON.stringify(lamSachChuoi(v));
}

const TEN_C0: Record<number, string> = { 0: "NUL", 1: "SOH", 2: "STX", 3: "ETX", 4: "EOT", 5: "ENQ", 6: "ACK", 7: "BEL — tiếng chuông", 8: "BS — lùi một ký tự", 11: "VT", 12: "FF", 14: "SO", 15: "SI", 16: "DLE", 17: "DC1", 18: "DC2", 19: "DC3", 20: "DC4", 21: "NAK", 22: "SYN", 23: "ETB", 24: "CAN", 25: "EM", 26: "SUB", 27: "ESC", 28: "FS", 29: "GS", 30: "RS", 31: "US", 127: "DEL" };

/** Ký tự điều khiển THẬT đầu tiên trong chuỗi (U+0000–U+0008, U+000B, U+000C, U+000E–U+001F, U+007F — Tab / xuống dòng KHÔNG tính) → "U+0001 (SOH)"; không có → null.
 *  Dấu gạch chéo ngược "\" và chữ "\n" gõ bằng hai ký tự KHÔNG phải ký tự điều khiển — chỉ ký tự mã nhỏ vô hình (thường do dán từ nơi khác) mới tới đây. */
export function kyTuDieuKhienDau(v: string): string | null {
  const m = /[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f]/.exec(v);
  if (!m) return null;
  const ma = m[0].charCodeAt(0);
  return `U+${ma.toString(16).toUpperCase().padStart(4, "0")} (${TEN_C0[ma] ?? "mã điều khiển"})`;
}

/** Câu báo lỗi cho ô chữ chứa ký tự điều khiển thật: nêu ĐÚNG ký tự + lý do + cách sửa. Không có ký tự như vậy → "". */
export function loiKyTuDieuKhien(nhan: string, v: string): string {
  const k = kyTuDieuKhienDau(v);
  return k ? `${nhan} chứa ký tự điều khiển ${k} — ký tự vô hình (thường dính vào khi dán chữ từ nơi khác), không hiện ra màn hình và làm hỏng bản chạy; hãy xoá ký tự đó hoặc gõ lại đoạn chữ này (dấu \\ và xuống dòng thì dùng bình thường)` : "";
}
